export default "__VITE_ASSET__CMw$JkDi__"